import { Component, OnInit } from '@angular/core';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { ResultsEventDetailsComponent } from '../../results-event-details/results-event-details.component';

@Component({
  selector: 'app-results-event-details-mobile',
  templateUrl: './results-event-details-mobile.component.html',
  styleUrls: ['./results-event-details-mobile.component.less']
})
export class ResultsEventDetailsMobileComponent extends ResultsEventDetailsComponent {

hideOutcomesWithoutOdds = ViewConfigurations.hideResultOutcomesIfNoOdd;
}
